import { createContext, createElement, useContext, type ReactNode } from 'react';

/**
 * Defaults to true so a board rendered without a provider (such as a component
 * test) keeps every control, as it did before levels existed. The server
 * refuses a view-only member's writes either way; this only decides whether
 * the board offers them.
 */
const TrackerCanEditContext = createContext(true);

export function TrackerAccessProvider({
  canEdit,
  children,
}: {
  canEdit: boolean;
  children: ReactNode;
}) {
  return createElement(TrackerCanEditContext.Provider, { value: canEdit }, children);
}

export function useCanEditTracker(): boolean {
  return useContext(TrackerCanEditContext);
}
